module.exports = __webpack_public_path__ + "img/招商银行.418126b7.png";